import React, { useEffect } from "react";
import { useCollectAnchorLinks } from "../../context/anchorLinksContextProvider";

//TODO: liaise with starlight team to confirm usecase and data tracking of this particular widget
//so we can optimise and simply this component logic.
const JobAdderWidget = ({ jobAdder, location, blockIndex = null }) => {
  let hasJobAdder = jobAdder || false;
  useCollectAnchorLinks("JobAdder Widget", "ja-jobs-widget-title", blockIndex);

  function param(name, url = location.href) {
    //original: name = name.replace(/[\[\]]/g, "\\$&");
    //changed due to "7:27  warning  Unnecessary escape character: \[  no-useless-escape"
    name = name.replace(/[[\]]/g, "\\$&");
    let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  function displayJAWidget(jaJobVal) {
    const jobWidgetDiv = document.getElementById("ja-jobs-widget");
    const hasJobAdderScript = document.getElementById("jobAdderScript");
    const hasJobAdderExternal = document.getElementById("jobAdderExternal");

    if (hasJobAdder && !hasJobAdderScript && !hasJobAdderExternal) {
      const jobAdderScriptEl = document.createElement("script");
      let key_used = "";
      switch (jobAdder) {
        case "Paid":
          key_used = process.env.GATSBY_JOBADDER_PAID_KEY;
          break;
        case "Volunteer":
          key_used = process.env.GATSBY_JOBADDER_VOLUNTEER_KEY;
          break;
        case "Demo":
          key_used = process.env.GATSBY_JOBADDER_DEMO_KEY;
          break;
        default:
          break;
      }
      jobAdderScriptEl.setAttribute("id", "jobAdderScript");
      jobAdderScriptEl.innerHTML = `
      var _jaJobsSettings = {
        key: '${key_used}',
        applicationFormSettings: {
          useExternalApplicationForm: true,
          showExternalApplicationFormInNewWindow: false
        },
        jobListSettings: {
          titleIsLink: true,
          jobsPerPage: 10,
          showSalary: false
        }
      };
      `;
      jobWidgetDiv.parentNode.insertBefore(jobAdderScriptEl, jobWidgetDiv.nextSibling);
      const jobAdderScript2 = document.getElementById("jobAdderScript");
      const jobAdderExternal = document.createElement("script");
      jobAdderExternal.setAttribute("id", "jobAdderExternal");
      jobAdderExternal.setAttribute("src", "//apps.jobadder.com/widgets/v1/jobs.min.js");
      jobAdderScript2.parentNode.insertBefore(jobAdderExternal, jobAdderScript2.nextSibling);
      document.getElementById("ja-jobs-widget-title").innerHTML = `${jobAdder === "Volunteer" ? "Volunteer opportunities" : "Careers at Starlight"}`;

      let eoi_url = "";
      switch (jobAdder) {
        case "Paid":
          eoi_url = process.env.GATSBY_JOBADDER_PAID_EOI_URL;
          break;
        case "Volunteer":
          eoi_url = process.env.GATSBY_JOBADDER_VOLUNTEER_EOI_URL;
          break;
        default:
          break;
      }

      const eoiIframeContainer = document.getElementById("ja-jobs-eoi-frame");
      if (eoi_url) {
        const eoiIframe = document.createElement("iframe");
        eoiIframe.setAttribute("id", "eoi-frame-content");
        eoiIframe.setAttribute("src", eoi_url);
        eoiIframe.setAttribute("scrolling", "no");
        // eoiIframeContainer.appendChild(eoiIframe); not display eoi iframe
        // document.getElementById('ja-no-jobs-text').innerHTML = 'If the right ' + (jobAdder === 'Volunteer' ? 'volunteer' : '') + ' opportunity for you isn’t listed, please express your interest and we’ll connect with you about future roles.<br /><br /><span id="form-instructions">Note: Max. 4 selections for both roles of interest and preferred locations. </span>';
        eoiIframeContainer.classList.add("add-space");
      } else {
        eoiIframeContainer.classList.add("add-space");
      }
    }
  }
  function displayJAWidgetText(jaJobVal) {
    const eoiText = document.getElementById("ja-no-jobs-text");
    let jobList;
    let checkJobs = setInterval(function () {
      jobList = document.querySelectorAll(".ja-job-list-container");
      if (jobList !== undefined && jobList.length && jobList[0].children[0].className !== "no-jobs-content") {
        eoiText.classList.add("has-jobs");
        clearInterval(checkJobs);
      }
    }, 250);
  }
  function showJADisplay(jaJobId) {
    const eoiIframeContainer = document.getElementById("ja-jobs-eoi-frame");
    const eoiText = document.getElementById("ja-no-jobs-text");
    if (+jaJobId === 0) {
      eoiIframeContainer.classList.remove("no-show");
      eoiText.classList.remove("no-show");
    }
  }

  function activateClickListener() {
    document.addEventListener(
      "click",
      (event) => {
        switch (event.target.className) {
          case "view-details":
            document.getElementById("ja-jobs-eoi-frame").classList.add("no-show");
            document.getElementById("ja-no-jobs-text").classList.add("no-show");
            let jaJobClick = event.target.dataset.jobId || 0;
            displayJAWidget();
            displayJAWidgetText();
            hasJobAdder && showJADisplay(jaJobClick);
            break;
          case "back-link":
            event.preventDefault();
            let url = event.target.baseURI.split("?")[0];
            document.location = url;
            break;
          default:
            break;
        }
      },
      true
    );
  }

  useEffect(() => {
    displayJAWidget();
  });
  useEffect(() => {
    displayJAWidgetText();
  });
  useEffect(() => {
    let jaJobVal = +param("ja-job") || 0;
    hasJobAdder && showJADisplay(jaJobVal);
  });
  useEffect(() => {
    activateClickListener();
  });

  return (
    <div className="jobadder-widget">
      <h2 id="ja-jobs-widget-title">JobAdder Widget</h2>
      <div id="ja-jobs-widget"></div>
      <div id="ja-no-jobs-text" className="no-show"></div>
      <div id="ja-jobs-eoi-frame" className="no-show"></div>
      <div className="ja-pager-container"></div>
    </div>
  );
};

export default JobAdderWidget;
